<template>
  <v-card class="vpd-panel vpd-profile-panel">
    <v-overlay :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <vpd-card-title title="Profil"></vpd-card-title>
    <v-alert
      v-model="alert"
      :type="alertType"
      close-text="Bezárás"
      dismissible
      @click="alert = false"
      >{{ alertMessage }}
    </v-alert>
    <v-row justify="center">
      <v-col align="center" class="pb-2">
        <div class="profil-label fix-width left">Név: {{ username }}</div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col align="center" class="pb-6">
        <div class="profil-label profile-email fix-width left">
          <span class="profile-email__label">Email:</span>
          <span class="profile-email__value">{{ email }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col align="center" class="pb-10">
        <div class="description fix-width left">
          A regisztrációkor megadott nevet és emailcímet biztonsági okokból nem lehet megváltoztatatni.
        </div>
        <div class="description fix-width left">
          Ha új emailcímet szeretne használni, azt a profilja törlésével majd új regisztráció létrehozásával teheti meg.
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col align="center">
        <v-btn
          class="primary huge fix-width"
          @click="redirectToChangePasswordPage"
          >Jelszó megváltoztatása
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isStatementProcessorEnabled" justify="center">
      <v-col align="center">
        <v-btn
          class="primary huge fix-width"
          :disabled="emailPdfSubmissionEnabled"
          :loading="enablingEmailPdfSubmission"
          @click="enableEmailPdfSubmission"
        >
          {{
            emailPdfSubmissionEnabled
              ? "Email cím elrejtése PDF beküldéshez"
              : "Email cím mutatása PDF beküldéshez"
          }}
        </v-btn>
        <div
          v-if="emailPdfSubmissionSettingLoaded"
          class="email-pdf-submission-status fix-width left mt-3"
        >
          <div>
            Emailes PDF-beküldés:
            <strong>{{
              emailPdfSubmissionEnabled ? "bekapcsolva" : "kikapcsolva"
            }}</strong>
          </div>
          <div v-if="emailPdfSubmissionEnabled" class="mt-1">
            A PDF-eket erre a címre küldje:<br />
            <strong class="email-pdf-submission-address">{{ emailPdfSubmissionAddress }}</strong>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col align="center" class="pt-10">
        <v-btn @click="wipeProfileInit" class="error fix-width huge"
          >Profil törlése
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import "./_vpd-profile-panel.scss";
import { fetchUserAttributes, getCurrentUser } from "@aws-amplify/auth";
import VpdCardTitle from "@/components/vpd-card-title/vpd-card-title";
import userService from "@/services/user-service";
import emailPdfSubmissionService from "@/services/email-pdf-submission-service";

export default {
  name: "vpd-profile-panel",
  components: { VpdCardTitle },
  props: {},
  data: () => ({
    alert: false,
    alertMessage: "",
    alertType: "error",
    valid: false,
    overlay: true,
    username: null,
    userId: null,
    email: null,
    dateCreated: null,
    profilePicture: false,
    enablingEmailPdfSubmission: false,
    emailPdfSubmissionEnabled: false,
    emailPdfSubmissionSettingLoaded: false,
  }),
  computed: {
    isStatementProcessorEnabled() {
      return this.$store.getters["general/statementProcessorEnabled"];
    },
    emailPdfSubmissionAddress() {
      if (window.location.href.includes("demoportal")) {
        return this.userId
        ? `${this.userId}@demoportal.bankszamlakivonat.hu`
        : "";
      } else {
        return this.userId
        ? `${this.userId}@portal.bankszamlakivonat.hu`
        : "";
      }
      
    },
  },
  methods: {
    async loadProfile() {
      this.overlay = true;
      console.log("loadProfile called");
      try {
        const user = await getCurrentUser();
        const attrs = await fetchUserAttributes();

        this.username = attrs.name || user.username;
        this.userId = attrs.sub || user.userId;
        this.email = attrs.email;

        if (attrs.identities) {
          this.federationConfig({ attributes: attrs });
        }

      } catch (err) {
        console.error("User profile error:", err);
        this.alertMessage = "Hiba történt a szerveren!";
        this.alertType = "error";
        this.alert = true;
      } finally {
        this.overlay = false;
      }
    },
    async federationConfig(data) {
      var identities = JSON.parse(data.attributes.identities)[0];
      if (identities.providerType == "Facebook") {
        this.federationLogin = true;
        this.profilePicture = JSON.parse(data.attributes.picture).data.url;
      }
      if (identities.providerType == "Google") {
        this.federationLogin = true;
        this.profilePicture = data.attributes.picture;
      }
    },
    routeToHome() {
      return this.$router.push("/");
    },
    redirectToChangePasswordPage() {
      this.$router.push({ name: "change-password" });
    },
    setGooglePicture() {},
    setFacebookPicture() {},
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", this.oldPassword, this.newPassword);
      }
    },
    async wipeProfileInit() {
      this.overlay = true;
      try {
        const result = await userService.wipeProfileInit();
        if (result) {
          this.alert = result.alert;
          this.alertType = result.alertType;
          this.alertMessage = result.alertMessage;
        }
      } catch (err) {
        this.alertMessage = "A profiltörlési kérelem elküldése sikertelen.";
        this.alertType = "error";
        this.alert = true;
      } finally {
        this.overlay = false;
      }
    },
    async enableEmailPdfSubmission() {
      this.enablingEmailPdfSubmission = true;
      try {
        await emailPdfSubmissionService.enable();
        await this.loadEmailPdfSubmissionSetting();

        if (!this.emailPdfSubmissionEnabled) {
          throw new Error("Email PDF submission is not enabled");
        }

        this.alertMessage = "Az emailes PDF-beküldés sikeresen bekapcsolva.";
        this.alertType = "success";
        this.alert = true;
      } catch (err) {
        this.alertMessage =
          "Az emailes PDF-beküldést nem sikerült bekapcsolni.";
        this.alertType = "error";
        this.alert = true;
      } finally {
        this.enablingEmailPdfSubmission = false;
      }
    },
    async loadEmailPdfSubmissionSetting() {
      const setting = await emailPdfSubmissionService.getSetting();
      const status = String(setting?.status || "").toLowerCase();
      const disabledStatuses = ["disabled", "inactive", "off"];

      this.emailPdfSubmissionEnabled =
        Boolean(setting) && !disabledStatuses.includes(status);
      this.emailPdfSubmissionSettingLoaded = true;
    },
  },
  created() {
    this.loadProfile();
  },
  watch: {
    '$store.state.general.userState': {
      immediate: true,
      handler(val) {
        if (val === 'signedIn') {
          console.log("userState changed called");
          this.loadProfile();
        }
      }
    }
  },
};
</script>
